import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChicken = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 80,
	height: 114,
	fill: "none",
	viewBox: "0 0 80 114",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#FA4969",
			d: "m13.4 1.17 2.42 1.72a4.47 4.47 0 0 1 1.87 3.64v2.82c0 .9-.74 1.65-1.65 1.65-.4 0-.77.14-1.07.39l-.18.15c-.2.16-.41.3-.65.39l-.04.01a2.6 2.6 0 0 1-2.3-.21l-.3-.2a2.11 2.11 0 0 0-1.82-.2 2.1 2.1 0 0 1-2.24-.55l-1.6-1.7c-.45-.49-.4-1.27.11-1.7.43-.35.55-.97.28-1.46L6.1 5.7a1.5 1.5 0 0 1 1.2-2.22l.54-.04c.35-.03.7-.16.98-.38L10.18 2c.14-.1.27-.24.38-.39a2.06 2.06 0 0 1 2.84-.43Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FDC564",
			d: "M56.75 103.7c-.27-.83-.57-4.05-.69-5.55v-3.47l-2.42 1.39c.46 2.54.9 7.84-1.04 8.67-2.42 1.04-3.45 4.51-2.76 5.2.69.7 4.15-3.12 4.5-2.08.34 1.04.34 4.51 2.41 5.55 2.08 1.04-.69-5.9 0-6.59.7-.7 6.23 2.08 5.2 0-1.04-2.08-4.85-2.08-5.2-3.12Zm-33.2-2.9c.09-.87 1.15-3.92 1.68-5.33l1.44-3.16-2.78.26c-.64 2.5-2.44 7.5-4.55 7.45-2.64-.06-5.02 2.66-4.68 3.58.34.92 5.07-1.1 4.95-.02-.12 1.1-1.56 4.25-.1 6.06 1.45 1.8 1.82-5.66 2.74-6 .91-.34 4.8 4.48 4.71 2.16-.07-2.32-3.53-3.9-3.41-5Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FDD183",
			d: "M51.31 14.1c-18.67-2.21-26.72 20-29.06 31.53C7.95 61.71 9.2 56.5.18 64.43c0 37.66 78.92 54.8 75.22 3.97-2.95-40.61-2.48-51.72-24.09-54.3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#F5A61D",
			d: "M74.24 35.77a77.8 77.8 0 0 1 3.05-6c-4.51 1.69-9.53 3.14-8.27 7.73 1.26 4.6 6.9 1.52 10.41.58.68-.19-4.02-1.61-5.2-2.31Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FDD183",
			d: "M11.11 38.34c9.29.8 21.81 14.58 26.91 21.36-1.96 1.12-7.5 3-13.96 1.51-6.45-1.48-11.32-15.86-12.95-22.87Zm39.98-27.75c6.9 6.26 8.52 24.8 8.47 33.3-2.24-.3-7.78-2.17-12.02-7.26-4.24-5.09.6-19.48 3.55-26.04Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FDD183",
			d: "M48.56 11.93c6.14 3.53 10.37 17.04 11.72 23.35-1.71.15-6.13-.33-10.11-3.42-3.99-3.09-2.74-14.57-1.61-19.93Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#393939",
			d: "M52.66 33.46c2.1-.37 3.27.63 4.03 1.34-.13-1.24-1.08-3.57-4.03-3.19-3.6.47-3.03 4.2-2.95 3.84.07-.36 1.2-1.68 2.95-1.99Z"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 2.11,
			cy: 1.41,
			fill: "#FCACA0",
			rx: 2.11,
			ry: 1.41,
			transform: "matrix(-1 .00102 .00102 1 51.75 40.9)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FDC564",
			d: "M28.96 62a13.7 13.7 0 0 1-12.79-9.65c-7 4.34 5.07 11.59 11.59 11.59 3.98 0 9.31-1.55 1.2-1.93Zm17.63 35.73C25.83 97.05 6.76 79.14 0 64.42c.97 25.59 32.1 36.45 45.86 35.48 5.56 0 19.34-1.56.73-2.17Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#D81416",
			d: "M27.04 36.25c2.64-.47 10.15-5.9 19.74-13.5 2.78-1.89 17.94-4.99 18.61-3.42-.58-5.5-8.74-9.74-11.06-10.92-17.93-14.33-34.75.4-37.13 0-2.38-.39.18 4.13 6.77 14.33v8.72c.85 1.83.44 5.26 3.07 4.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#4E4A4A",
			d: "m39.13 18.13 2.48 1.89c.13.1.3.1.44.02l10.33-6.55c.13-.08.2-.23.18-.38-.23-1.82.06-3.85.7-3.85.84 0 2.78.17 4.8 1.54.8.53 2.38 1.93 3.39 2.55l.56-1.87c-.45-.37-1-.82-1.62-1.29l-7.8-6.22c-9.43-8.21-16.7 2.51-19.25 9.13a.37.37 0 0 0 .12.43l5.67 4.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#4E4A4A",
			d: "m23.94 30.9 16.07-14.67-3.94-1.98-12.13 9.31v7.33Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#4F5A5B",
			d: "M50.17 12c-.46-1.58.94-3.67 1.69-4.52 1.35-.9 5.45.76 7.33 1.7l-7.33-5.93c-.85-.09-2.77-.5-5.92-.28-3.16.23-8.09 6.68-9.87 9.6 2.06 1.5 6.42 4.45 7.33 4.22.9-.22 4.89-3.29 6.77-4.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#18A0FB",
			d: "M27.04 36.25c2.64-.47 10.15-5.9 19.74-13.5 2.78-1.89 17.94-4.99 18.61-3.42-.58-5.5-8.74-9.74-11.06-10.92-17.93-14.33-34.75.4-37.13 0-2.38-.39.18 4.13 6.77 14.33v8.72c.85 1.83.44 5.26 3.07 4.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#4E4A4A",
			d: "m39.13 18.13 2.48 1.89c.13.1.3.1.44.02l10.33-6.55c.13-.08.2-.23.18-.38-.23-1.82.06-3.85.7-3.85.84 0 2.78.17 4.8 1.54.8.53 2.38 1.93 3.39 2.55l.56-1.87c-.45-.37-1-.82-1.62-1.29l-7.8-6.22c-9.43-8.21-16.7 2.51-19.25 9.13a.37.37 0 0 0 .12.43l5.67 4.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#4E4A4A",
			d: "m23.94 30.9 16.07-14.67-3.94-1.98-12.13 9.31v7.33Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#4F5A5B",
			d: "M50.17 12c-.46-1.58.94-3.67 1.69-4.52 1.35-.9 5.45.76 7.33 1.7l-7.33-5.93c-.85-.09-2.77-.5-5.92-.28-3.16.23-8.09 6.68-9.87 9.6 2.06 1.5 6.42 4.45 7.33 4.22.9-.22 4.89-3.29 6.77-4.8Z"
		})
	]
});
export default SvgChicken;
